import { usePrevious } from '@mantine/hooks';
import { useMemo } from 'react';

export function useHasChanged<T>(value?: T, equalityTest?: (a: T | undefined, b: T | undefined) => boolean): boolean {
	const previous = usePrevious(value);

	const changed = useMemo(() => {
		// Check for strict equality
		const strictEqual = value === previous;
		if (strictEqual) {
			return false;
		}

		// If we don't have an equality test, consider a difference in equality as a change
		if (equalityTest === undefined) {
			return true;
		}

		return !equalityTest(value, previous);
	}, [value, previous, equalityTest]);

	return changed;
}
